import { api } from '@/services/api/AxiosBaseService'
import type { SingleResponse } from '@/types/api'

export type AutomationReportStatus = 'PENDENTE' | 'PROCESSANDO' | 'CONCLUIDO' | 'FALHOU'

export interface AutomationReport {
  id: string
  userId: string | null
  key: string
  metadata: Record<string, unknown> | null
  status: AutomationReportStatus
  filePath: string | null
  generatedAt: string | null
  errorMessage: string | null
  createdAt: string
}

export const AutomationReportsService = {
  async create(key: string, metadata?: Record<string, unknown>): Promise<AutomationReport> {
    const res = await api.post<SingleResponse<AutomationReport>>('/automation/reports', { key, metadata })
    return res.data.data
  },
  async show(id: string): Promise<AutomationReport> {
    const res = await api.get<SingleResponse<AutomationReport>>(`/automation/reports/${id}`)
    return res.data.data
  },
  /** Última geração CONCLUÍDA da key (ou null). */
  async latest(key: string): Promise<AutomationReport | null> {
    const res = await api.get<SingleResponse<AutomationReport | null>>('/automation/reports/latest', { params: { key } })
    return res.data.data
  },
}
